const MessengerIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="26"
    height="26"
    viewBox="0 0 26 26"
    aria-label="messenger-icon"
  >
    <g fill="none" fillRule="evenodd">
      <path
        fill="white"
        d="M5.2 20.8v4.4l4.2-2.4c1.2.4 2.4.6 3.6.6 6.8 0 12.2-5.2 12.2-11.4C25.2 5.6 19.8.6 13 .6 6.2.6.8 5.8.8 12c0 3.4 1.6 6.6 4.4 8.8z"
      />
      <path
        fill="#0096FF"
        d="M11.6 8.8l-6.6 7 6-3.4 3.2 3.4 6.6-7-6 3.2-3.2-3.2z"
      />
    </g>
  </svg>
);

export default MessengerIcon;
